module.exports = __webpack_public_path__ + "static/Christian_Activist-8b426e5d87ac53132ee7128df3feed5e.png";